import { useLocation } from "react-router-dom";

const CIUDADES = ["Ábrego","Acacías","Aguachica","Aguadas","Aguazul","Albán","Anapoima","Andes","Anserma","Apartadó","Aquitania","Aracataca","Arauca","Arauquita","Arjona","Armenia","Ayapel","Bahía Solano","Baranoa","Barbosa","Barrancabermeja","Barranquilla","Belén de los Andaquíes","Belén de Umbría","Bello","Bogotá D.C.","Bosconia","Bucaramanga","Buenaventura","Buga","Cajicá","Calamar","Calarcá","Caldas","Cali","Campoalegre","Candelaria","Carepa","Carmen de Viboral","Cartagena","Cartagena del Chairá","Cartago","Caucasia","Cereté","Chaparral","Chía","Chigorodó","Chinchiná","Chinú","Chiquinquirá","Chiriguaná","Ciénaga","Cimitarra","Circasia","Codazzi","Condoto","Copacabana","Corozal","Cota","Cravo Norte","Cúcuta","Cumaral","Cumaribo","Curumaní","Dosquebradas","Duitama","El Banco","El Bordo","El Carmen de Bolívar","El Doncello","El Retiro","El Retorno","Envigado","Espinal","Facatativá","Filandia","Flandes","Florencia","Florida","Floridablanca","Fonseca","Fortul","Fundación","Funza","Fusagasugá","Gachancipá","Galapa","Garzón","Gigante","Girardot","Girardota","Girón","Granada","Guarne","Honda","Ibagué","Inírida","Ipiales","Istmina","Itagüí","Jamundí","Jericó","La Calera","La Ceja","La Dorada","La Estrella","La Jagua de Ibirico","La Mesa","La Plata","La Primavera","La Tebaida","La Unión","La Virginia","Lebrija","Leticia","Líbano","Lorica","Los Patios","Madrid","Magangué","Maicao","Majagual","Málaga","Malambo","Manaure","Manizales","María la Baja","Marinilla","Mariquita","Marsella","Medellín","Melgar","Miraflores","Mitú","Mocoa","Mompox","Monguí","Moniquirá","Montelíbano","Montenegro","Montería","Monterrey","Mosquera","Necoclí","Neiva","Nobsa","Nuquí","Ocaña","Orito","Orocué","Pacho","Paipa","Palmar de Varela","Palmira","Pamplona","Pasto","Patía","Paz de Ariporo","Pereira","Piedecuesta","Piendamó","Pitalito","Planeta Rica","Plato","Polonuevo","Popayán","Pradera","Providencia","Puerto Asís","Puerto Boyacá","Puerto Carreño","Puerto Colombia","Puerto López","Puerto Nariño","Puerto Rico","Puerto Rondón","Puerto Tejada","Quibdó","Quimbaya","Restrepo","Riohacha","Rionegro","Riosucio","Rivera","Roldanillo","Sabanalarga","Sabaneta","Sáchica","Sahagún","Salamina","Samacá","Sampués","San Andrés","San Gil","San José del Guaviare","San Juan del Cesar","San Marcos","San Martín","San Miguel","San Vicente del Caguán","Sandoná","Santa Catalina","Santa Fe de Antioquia","Santa Marta","Santa Rosa","Santa Rosa de Cabal","Santa Rosalía","Santander de Quilichao","Santo Tomás","Santuario","Saravena","Sevilla","Sibaté","Sibundoy","Silvia","Sincelejo","Soacha","Soatá","Socorro","Sogamoso","Soledad","Sonsón","Sopó","Supía","Tabio","Tadó","Tame","Tauramena","Tenjo","Tibasosa","Tibú","Tierralta","Tocancipá","Tolú","Toluviejo","Trinidad","Tuluá","Tumaco","Tunja","Túquerres","Turbaco","Turbana","Turbo","Tuta","Ubaté","Uribia","Valledupar","Vélez","Ventaquemada","Villa de Leyva","Villa del Rosario","Villagarzón","Villamaría","Villanueva","Villavicencio","Villeta","Yarumal","Yopal","Yumbo","Zarzal","Zipaquirá"];

const CHIPS_PASOS = [
    { key: "paso1", icon: "bi-toggles",        label: "Paso 1 incompleto", title: "Sin tipo de servicio seleccionado (Digital / Presencial)" },
    { key: "paso2", icon: "bi-file-text",       label: "Paso 2 incompleto", title: "Falta nombre, descripción, categoría o subcategoría" },
    { key: "paso3", icon: "bi-images",          label: "Paso 3 incompleto", title: "Sin fotos subidas" },
    { key: "paso4", icon: "bi-box-seam",        label: "Paso 4 incompleto", title: "Sin paquetes de precio creados" },
    { key: "paso5", icon: "bi-chat-left-text",  label: "Paso 5 incompleto", title: "Sin preguntas frecuentes (FAQ)" },
];

const CHIPS_CONTACTO = [
    { key: "sinWA",       icon: "bi-whatsapp",      label: "Sin WA",      title: "No se les ha enviado mensaje por WhatsApp" },
    { key: "sinEmail",    icon: "bi-envelope",      label: "Sin correo",  title: "No se les ha enviado correo" },
    { key: "sinApp",      icon: "bi-phone",         label: "Sin app",     title: "No han recibido notificación push" },
    { key: "sinTelefono", icon: "bi-telephone-x",   label: "Sin llamada", title: "No se ha registrado llamada telefónica" },
];

const CHIPS_TIPO = [
    { key: "esDigital",    icon: "bi-laptop",    label: "Digital",    title: "Servicios de tipo Digital" },
    { key: "esPresencial", icon: "bi-geo-alt",   label: "Presencial", title: "Servicios de tipo Presencial" },
    { key: "esUrgente",    icon: "bi-lightning", label: "Urgente",    title: "Servicios marcados como urgentes" },
];

const CATEGORIAS = [
    "Veterinaria", "Mascotas", "Lavandería", "Jardinería", "Aseo",
    "Educación", "Construcción", "Transporte", "Eventos", "Legal",
    "Belleza", "Salud", "Digital", "Floristería", "Chef a domicilio",
    "Deporte & Fitness", "Hogar & Reparaciones", "Fotografía & Video",
    "Peluquería & Barbería", "Contabilidad & Finanzas", "Cuidado de personas",
    "Bienestar & Espiritualidad", "Marketing & Publicidad", "Tecnología & Soporte",
];

const VACIO = {
    falta1: false,
    paso1: false, paso2: false, paso3: false, paso4: false, paso5: false,
    sinWA: false, sinEmail: false, sinApp: false, sinTelefono: false,
    esDigital: false, esPresencial: false, esUrgente: false,
    categoria: "",
    ciudad: "",
};

function FiltrosServicios({ filtros, onChange, tab }) {
    const { pathname } = useLocation();
    const esBorrador       = tab === "Borrador";
    const mostrarCategoria = pathname === "/admin/servicios";

    function toggle(key) {
        onChange({ ...filtros, [key]: !filtros[key] });
    }

    function seleccionarCategoria(cat) {
        onChange({ ...filtros, categoria: filtros.categoria === cat ? "" : cat });
    }

    const hayFiltros = Object.entries(filtros).some(([k, v]) => (k === "categoria" || k === "ciudad") ? v !== "" : v);

    return (
        <div className="d-flex flex-column gap-2">

            {/* Categoría — solo /admin/servicios */}
            {mostrarCategoria && (
                <div className="d-flex align-items-start gap-2 flex-wrap">
                    <span className="text-muted small fw-semibold flex-shrink-0" style={{ fontSize: "0.8rem", minWidth: 80, paddingTop: 4 }}>Categoría:</span>
                    <div className="d-flex gap-1 flex-wrap">
                        <button
                            type="button"
                            className={`btn btn-sm rounded-pill ${filtros.categoria === "__sin_categoria__" ? "btn-warning text-dark" : "btn-outline-secondary"}`}
                            style={{ fontSize: "0.75rem" }}
                            onClick={() => seleccionarCategoria("__sin_categoria__")}
                        >
                            <i className="bi bi-question-circle me-1"></i>Sin categoría
                        </button>
                        {CATEGORIAS.map(cat => (
                            <button
                                key={cat}
                                type="button"
                                className={`btn btn-sm rounded-pill ${filtros.categoria === cat ? "btn-primary" : "btn-outline-secondary"}`}
                                style={{ fontSize: "0.75rem" }}
                                onClick={() => seleccionarCategoria(cat)}
                            >
                                {cat}
                            </button>
                        ))}
                    </div>
                </div>
            )}

            {/* Prioridad — solo Borrador */}
            {esBorrador && (
                <div className="d-flex align-items-center gap-2 flex-wrap">
                    <span className="text-muted small fw-semibold" style={{ fontSize: "0.8rem", minWidth: 80 }}>Prioridad:</span>
                    <button
                        type="button"
                        title="Servicios a los que solo les falta 1 paso para publicar"
                        className={`btn btn-sm rounded-pill ${filtros.falta1 ? "btn-success text-white" : "btn-outline-secondary"}`}
                        style={{ fontSize: "0.78rem" }}
                        onClick={() => toggle("falta1")}
                    >
                        <i className="bi bi-star me-1"></i>Le falta 1 paso
                    </button>
                </div>
            )}

            {/* Pasos incompletos — solo Borrador */}
            {esBorrador && (
                <div className="d-flex align-items-center gap-2 flex-wrap">
                    <span className="text-muted small fw-semibold" style={{ fontSize: "0.8rem", minWidth: 80 }}>Incompleto:</span>
                    {CHIPS_PASOS.map(({ key, icon, label, title }) => (
                        <button
                            key={key}
                            type="button"
                            title={title}
                            className={`btn btn-sm rounded-pill ${filtros[key] ? "btn-warning text-dark" : "btn-outline-secondary"}`}
                            style={{ fontSize: "0.78rem" }}
                            onClick={() => toggle(key)}
                        >
                            <i className={`${icon} me-1`}></i>{label}
                        </button>
                    ))}
                </div>
            )}

            {/* Contacto — solo Borrador */}
            {esBorrador && (
                <div className="d-flex align-items-center gap-2 flex-wrap">
                    <span className="text-muted small fw-semibold" style={{ fontSize: "0.8rem", minWidth: 80 }}>Contacto:</span>
                    {CHIPS_CONTACTO.map(({ key, icon, label, title }) => (
                        <button
                            key={key}
                            type="button"
                            title={title}
                            className={`btn btn-sm rounded-pill ${filtros[key] ? "btn-dark" : "btn-outline-secondary"}`}
                            style={{ fontSize: "0.78rem" }}
                            onClick={() => toggle(key)}
                        >
                            <i className={`${icon} me-1`}></i>{label}
                        </button>
                    ))}
                </div>
            )}

            {/* Ciudad — todos los tabs */}
            <div className="d-flex align-items-center gap-2 flex-wrap">
                <span className="text-muted small fw-semibold flex-shrink-0" style={{ fontSize: "0.8rem", minWidth: 80 }}>Ciudad:</span>
                <select
                    className="form-select form-select-sm rounded-pill"
                    style={{ width: "auto", minWidth: 180, fontSize: "0.78rem" }}
                    value={filtros.ciudad}
                    onChange={e => onChange({ ...filtros, ciudad: e.target.value })}
                >
                    <option value="">Todas las ciudades</option>
                    {CIUDADES.map(c => (
                        <option key={c} value={c}>{c}</option>
                    ))}
                </select>
            </div>

            {/* Tipo de servicio — todos los tabs */}
            <div className="d-flex align-items-center gap-2 flex-wrap">
                <span className="text-muted small fw-semibold" style={{ fontSize: "0.8rem", minWidth: 80 }}>Tipo:</span>
                {CHIPS_TIPO.map(({ key, icon, label, title }) => (
                    <button
                        key={key}
                        type="button"
                        title={title}
                        className={`btn btn-sm rounded-pill ${filtros[key] ? "btn-dark" : "btn-outline-secondary"}`}
                        style={{ fontSize: "0.78rem" }}
                        onClick={() => toggle(key)}
                    >
                        <i className={`${icon} me-1`}></i>{label}
                    </button>
                ))}
                {hayFiltros && (
                    <button
                        type="button"
                        className="btn btn-sm btn-link text-danger p-0 text-decoration-none"
                        style={{ fontSize: "0.78rem" }}
                        onClick={() => onChange(VACIO)}
                    >
                        <i className="bi bi-x me-1"></i>Limpiar
                    </button>
                )}
            </div>

        </div>
    );
}

export default FiltrosServicios;
